const STORAGE_KEY = "unfold_auth_message";

/** Queues a message for the login page to show after the next redirect there. */
export function storeAuthError(text: string): void {
  sessionStorage.setItem(STORAGE_KEY, text);
}

export function consumeStoredAuthError(): string | null {
  const v = sessionStorage.getItem(STORAGE_KEY);
  if (v) sessionStorage.removeItem(STORAGE_KEY);
  return v;
}
